var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "Banner",
        {
          staticClass: "campaign-landing-page-banner",
          class: {
            "campaign-landing-page-banner--override":
              _vm.$config.campaignLandingPageBannerOverride
          },
          attrs: {
            "background-image": _vm.$config.campaignLandingPageBannerOverride
              ? _vm.$store.state.imagesCdn +
                "/" +
                _vm.$config.campaignLandingPageBannerOverride.staticImagePath
              : _vm.$store.state.imagesCdn + "/default-banner-marquee-lt.jpg"
          }
        },
        [
          _c("div", {
            staticClass: "banner__title",
            domProps: {
              innerHTML: _vm._s(
                _vm.$config.campaignLandingPageBannerOverride
                  ? _vm.$config.campaignLandingPageBannerOverride.title
                  : "<div>Get into the biggest concerts and the hottest shows!</div>"
              )
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("div", {
                staticClass: "banner__tagline",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$config.campaignLandingPageBannerOverride
                      ? _vm.$config.campaignLandingPageBannerOverride.tagline
                      : "See your favorite artists, comedians and performers live"
                  )
                }
              }),
              _vm._v(" "),
              (_vm.$config.campaignLandingPageBannerOverride || {}).termsModal
                ? _c(
                    "router-link",
                    {
                      staticClass: "banner_terms-link",
                      attrs: {
                        to: {
                          query: _vm.updateQueryParams(_vm.$route.query, {
                            modal: "terms"
                          })
                        }
                      }
                    },
                    [_vm._v("\n                    Terms\n            ")]
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "music-section" },
        [
          _c("h2", { staticClass: "section-header" }, [
            _vm._v("Shop the Hottest Tours")
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { mode: "out-in", name: "fade" } }, [
            !_vm.isLoading.musicEvents
              ? _c(
                  "section",
                  [
                    _c(
                      "transition-group",
                      {
                        staticClass: "event-list",
                        attrs: { name: "list", tag: "ul" }
                      },
                      _vm._l(_vm.orderedEventList.music, function(musicEvent) {
                        return _c(
                          "li",
                          { key: musicEvent.id, staticClass: "performer-tile" },
                          [
                            _c("promotedEvent", {
                              attrs: {
                                images: musicEvent.images,
                                "artist-name": musicEvent.name,
                                "event-count": musicEvent.numberOfEvents,
                                "artist-id": musicEvent.id
                              },
                              nativeOn: {
                                click: function($event) {
                                  _vm.eventSelected(musicEvent.name)
                                }
                              }
                            })
                          ],
                          1
                        )
                      })
                    ),
                    _vm._v(" "),
                    _vm.isMoreEventsAvailable("music")
                      ? _c(
                          "button",
                          {
                            staticClass: "show-more",
                            on: {
                              click: function($event) {
                                _vm.fetchMorePerformers("music")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.showMoreButtonCopy("music")) +
                                "\n                "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm.isLoading.musicEvents
              ? _c("section", { staticClass: "loading" }, [_c("fx-spinner")], 1)
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "section-divider" }),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "theatre-section" },
        [
          _c("h2", { staticClass: "section-header" }, [
            _vm._v("Shop the Biggest Shows")
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { mode: "out-in", name: "fade" } }, [
            !_vm.isLoading.theatreEvents
              ? _c(
                  "section",
                  [
                    _c(
                      "transition-group",
                      {
                        staticClass: "event-list",
                        attrs: { name: "list", tag: "ul" }
                      },
                      _vm._l(_vm.orderedEventList.theatre, function(
                        theatreEvent
                      ) {
                        return _c(
                          "li",
                          {
                            key: theatreEvent.id,
                            staticClass: "performer-tile"
                          },
                          [
                            _c("promotedEvent", {
                              attrs: {
                                "artist-id": theatreEvent.id,
                                "artist-name": theatreEvent.name,
                                "event-count": theatreEvent.numberOfEvents,
                                images: theatreEvent.images
                              },
                              nativeOn: {
                                click: function($event) {
                                  _vm.eventSelected(theatreEvent.name)
                                }
                              }
                            })
                          ],
                          1
                        )
                      })
                    ),
                    _vm._v(" "),
                    _vm.isMoreEventsAvailable("theatre")
                      ? _c(
                          "button",
                          {
                            staticClass: "show-more",
                            on: {
                              click: function($event) {
                                _vm.fetchMorePerformers("theatre")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.showMoreButtonCopy("theatre")) +
                                "\n                    "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm.isLoading.theatreEvents
              ? _c("section", { staticClass: "loading" }, [_c("fx-spinner")], 1)
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      (_vm.$config.campaignLandingPageBannerOverride || {}).termsModal
        ? _c(
            "modal",
            {
              staticClass: "terms-modal",
              attrs: { size: "large", open: _vm.isTermsModalOpen },
              on: { close: _vm.closeModal }
            },
            [
              _c("h1", {
                staticClass: "terms-modal-heading",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$config.campaignLandingPageBannerOverride.termsModal
                      .header
                  )
                }
              }),
              _vm._v(" "),
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$config.campaignLandingPageBannerOverride.termsModal
                      .content
                  )
                }
              })
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }